// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"1aac4592","25":"1abaca6a","259":"ac4ef91a","557":"17a03b6f","621":"761f61b5","637":"aee71916","717":"ebf56bc6","741":"5793bbfd"}[chunkId] + ".chunk.js";
};